import { gql } from '@apollo/client';

// TODO: Clean these up and simplify Basic/Minimal version

export const AIRPORT_BASIC_FRAGMENT = gql`
  fragment AirportBasic on Airport {
    id
    name
    identifier
    iataCode
    icaoCode
    type
    latitude
    longitude
    isoCountry
    timezoneId
  }
`;

export const AIRPORT_DETAIL_FRAGMENT = gql`
  fragment AirportDetail on Airport {
    ...AirportBasic
    homeLink
    wikipediaLink
    iataCodeFormer
    gpsCode
    localCode
    isoRegion
  }
  ${AIRPORT_BASIC_FRAGMENT}
`; 